import PartnerLogos from "../../../../src/components/PartnerLogos";
import TeamBio from "../../../../src/components/TeamBio";
import VersionInfo from "../../../../src/components/VersionInfo";
import * as React from 'react';
export default {
  PartnerLogos,
  TeamBio,
  VersionInfo,
  React
};